var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9604 5.46565C13.3611 5.86668 12.8828 6.51701 12.3803 6.25423C12.1835 6.15141 11.9421 6.19257 11.7899 6.35435L9.37302 8.92448C9.20615 9.10222 9.18843 9.3736 9.33089 9.57149C9.69654 10.0801 8.99998 10.6723 8.55679 10.2296L7.38148 9.05429L5.21731 11.2184C5.13291 11.3028 5.03618 11.3745 4.93073 11.4304L3.78373 12.0387C3.57479 12.1495 3.34839 11.9231 3.45918 11.7142L4.06755 10.5672C4.12346 10.4618 4.19515 10.3651 4.27955 10.2807L6.44372 8.11656L5.27186 6.94475C4.82858 6.50149 5.42118 5.80444 5.92995 6.17067C6.12785 6.31313 6.39925 6.29542 6.57699 6.12855L9.14721 3.71173C9.30905 3.55953 9.34961 3.31751 9.24665 3.12064C8.98418 2.61819 9.63498 2.14035 10.0359 2.54129L12.9604 5.46565Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.9229f7daf121c6379591f40686cd1d2f.svg";
export { ForwardRef as ReactComponent };